import apiV2 from "api-v2";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Same endpoints the legacy `EditDropdown` (`components/Pages/RFQ/EditDropdown`)
 * posted to (`rfq/{id}/archived` / `rfq/{id}/unarchived`) — reused as-is, no new
 * backend surface introduced (PRO-637 Task 018 boundary).
 */
const archiveRfx = (id: number) => apiV2.post(`rfq/${id}/archived`);
const unarchiveRfx = (id: number) => apiV2.post(`rfq/${id}/unarchived`);

/**
 * PERMANENT delete — drafts only. Distinct from `DELETE rfq/{id}`, which
 * soft-deletes. The server enforces the draft-only rule (`forceDestroy` +
 * `RfxHardDeleteService`); the UI gate is a convenience, not the guard.
 */
const forceDeleteRfx = (id: number) => apiV2.delete(`rfq/${id}/force-delete`);

export const useArchiveRfx = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: archiveRfx,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["rfx-list"] });
		},
	});
};

export const useUnarchiveRfx = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: unarchiveRfx,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["rfx-list"] });
		},
	});
};

export const useForceDeleteRfx = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: forceDeleteRfx,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["rfx-list"] });
		},
	});
};
